import React from 'react';
import TranslatedText from '../../../translations/TranslatedText';

const SignUpInfo = () => (
    <div className="signup-info">
        <h3>
            <TranslatedText transKey="Dear collectors" />
            <br />
            <TranslatedText transKey="Welcome" />
        </h3>
        <div className="info">
            <TranslatedText transKey="Signup info p1" />
            {' '}
            <span className="font-underline">
                <TranslatedText transKey="your online collection p1" />
            </span>
            {' '}
            <TranslatedText transKey="your online collection p2" />
        </div>
        <div className="info">
            <TranslatedText transKey="Signup info p2" /><br/>
            <TranslatedText transKey="Signup info p3" />
        </div>
        <div className="info">
            <span className="font-bold font-underline">
                <TranslatedText transKey="Attention:" />
            </span>
            <br />
            <span className="font-bold">
                <TranslatedText transKey="Signup info p4" />
            </span>
        </div>
        <div className="info">
            <span className="font-bold font-underline">
                <TranslatedText transKey="contact" />
            </span>
            <br/>
            <i className="icon-icon_mail"/>
            {' '}:{' '}
            <a href="mailto:eeckman@artefile.eu">eeckman@artefile.eu</a>
            <br/>
            <i className="icon-icon_contact"/> : +32 475 52 19 97

        </div>
        <div className="info">
            <TranslatedText transKey="Signup info p5" />
        </div>
    </div>
);

SignUpInfo.propTypes = {};
SignUpInfo.defaultProps = {};

export default SignUpInfo;



// WEBPACK FOOTER //
// ./src/scenes/SignUp/components/SignUpInfo.js